import React, { useCallback, useMemo, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, getActions, addActionOnRow, rowPhoto } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { EventForm } from '../event-form/EventForm'
import { useSelector } from 'react-redux'
import { EventZoneView } from '../../event-zone'

export const EventView = () => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/event'
  })

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'eventos' })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_event

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <EventForm rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/event/delete',
            data: {
              p_id_event: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
      size="lg"
      addButtonRow={({ setModalShow, setModalTitle, setCustomForm, rowId, setForm, data }) => {
        const addActions = []
        if (actions?.zonas) {
          addActions.push({
            icon: actions?.zonas.icon_action,
            variant: actions?.zonas.color_action,
            onClick: _ => {
              setModalTitle('Listado de Zonas de Evento ')
              setCustomForm(true)
              setForm(<div>
                <div className='mb-3'><strong>Evento: </strong> {data.name_event}</div>

                <EventZoneView eventId={rowId} />
              </div>)
              setModalShow(true)
            }
          })
        }

        return addActions
      }}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        { name: 'name_event', text: 'Nombre', align: 'center' },
        {
          name: 'banner_small_event', text: 'Foto', render: row => rowPhoto(row.banner_small_event, row.name_event), align: 'center'
        },
        { name: 'name_type_event', text: 'Tipo Evento', align: 'center' },
        { name: 'date_event', text: 'Fecha', align: 'center' },
        { name: 'hour_event', text: 'Hora', align: 'center' },
        { name: 'enabled_event', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_event }) },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          {rowItem({
            type: 'create'
          })}
          {dtRows}
        </Card.Body>
      </Card>
    </div>
  </div>
}